import React from "react";
import { LuPhone } from "react-icons/lu";
import { CgMail } from "react-icons/cg";
import { IoLocationOutline } from "react-icons/io5";

const Navbar = () => {
  return (
    <div className="hidden lg:block">
      {" "}
      <div className="h-16 flex justify-between items-center bg-[#272F3D] text-white px-20">
        <div className="flex justify-center items-center gap-9">
          <div className="flex justify-center items-center gap-2">
            <LuPhone className="text-white h-5 w-5" />
            <p className="text-lg inter">+91 9937100000 </p>
          </div>
          <div className="flex justify-center items-center gap-2">
            <CgMail className="text-white h-6 w-6" />
            <p className="text-lg inter">infosailesh@gmail.com</p>
          </div>
        </div>
        <div className="flex justify-center items-center gap-2">
          <IoLocationOutline className="text-white h-5 w-5" />
          <p className="text-lg inter">Bhubaneswar, Odisha</p>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
